<div class="content-info">
    <div class="content-title d-flex justify-content-between align-items-center">
        <div>
            <h3 class="title mb-0">Terminals</h3>
            @if (lastRefreshedAt) {
            <small class="text-muted">
                Live · updated {{ relativeTime(lastRefreshedAt.toISOString()) }}
            </small>
            }
        </div>
        <div class="d-flex align-items-center gap-2">
            <div class="form-group mb-0" style="min-width: 220px;">
                <select class="form-select" [(ngModel)]="selectedStoreId" (change)="onStoreFilterChange()">
                    <option value="">All stores</option>
                    @for (store of stores; track store.id) {
                    <option [value]="store.id">{{ store.name }}</option>
                    }
                </select>
            </div>
            <button class="btn btn-outline-primary text-nowrap" (click)="fetch()">
                <i class="bi bi-arrow-clockwise me-1"></i> Refresh
            </button>
        </div>
    </div>

    <div class="common-table mt-4">
        <div class="table-responsive">
            <table class="table align-middle">
                <thead>
                    <tr>
                        <th>Store</th>
                        <th>Terminal</th>
                        <th>Status</th>
                        <th>Day</th>
                        <th>Last seen</th>
                        <th class="text-end">Today's bills</th>
                        <th>Cashier</th>
                        <th class="text-end">Queue</th>
                        <th class="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @if (loading) {
                    <tr>
                        <td colspan="9" class="text-center py-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </td>
                    </tr>
                    } @else {
                    @for (t of terminals; track trackById($index, t)) {
                    <tr>
                        <td>
                            <div class="fw-semibold text-dark">{{ t.store?.name || '—' }}</div>
                            <div class="small text-muted">{{ t.store?.storeCode }}</div>
                        </td>
                        <td>
                            <div class="fw-semibold text-dark">{{ t.terminalName }}</div>
                            <div class="small text-muted">#{{ t.terminalNumber }}</div>
                        </td>
                        <td>
                            <span class="fw-semibold" [ngClass]="statusPill(t).cls">
                                {{ statusPill(t).dot }} {{ statusPill(t).label }}
                            </span>
                        </td>
                        <td>
                            @if (isDayOpen(t)) {
                            <span class="badge bg-success-subtle text-success border border-success-subtle">Open</span>
                            } @else {
                            <span class="badge bg-light text-muted border">Closed</span>
                            }
                        </td>
                        <td>
                            <span [class.text-muted]="!t.online">{{ relativeTime(t.lastSeenAt) }}</span>
                        </td>
                        <td class="text-end">{{ t.todaysBillCount || 0 }}</td>
                        <td>{{ t.currentCashier?.name || '—' }}</td>
                        <td class="text-end">
                            @if (t.queuedBills > 0) {
                            <span class="badge bg-warning-subtle text-warning border border-warning-subtle">
                                {{ t.queuedBills }}
                            </span>
                            } @else {
                            <span class="text-muted">0</span>
                            }
                        </td>
                        <td>
                            <div class="d-flex justify-content-end">
                                @if (t.status === 'decommissioned') {
                                <span class="small text-muted">—</span>
                                } @else {
                                <div class="form-check form-switch m-0 d-inline-flex align-items-center">
                                    <input class="form-check-input" type="checkbox"
                                        [checked]="t.status === 'active'"
                                        [disabled]="togglingIds.has(t.id)"
                                        (change)="toggleStatus(t)" />
                                    <span class="ms-2 small"
                                        [class.text-success]="t.status === 'active'"
                                        [class.text-muted]="t.status !== 'active'">
                                        {{ t.status === 'active' ? 'Enabled' : 'Disabled' }}
                                    </span>
                                </div>
                                }
                            </div>
                        </td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="9" class="text-center py-5 text-muted">
                            No terminals registered yet.
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
